import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {UserSubscription} from "../../../../user/user-subscription";
import {Website} from "../../website";
import {filter, first, switchMap, takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../store';
import {TypeUtils} from "../../../../shared/utils/type-utils";
import {IBoosterStats} from "../../../../store/reducers/booster.reducer";
import {User} from "../../../../user/user";
import {combineLatest} from "rxjs";
import {BuilderSectionsInteractionService} from "../../../../builder-v2/builder-sections-interaction.service";

@Component({
    selector: 'db-back-end',
    templateUrl: './back-end.component.html',
    styleUrls: ['./back-end.component.scss'],
    standalone: false
})
export class BackEndComponent implements OnInit {

  public currentSubscription: UserSubscription;
  public website: Website;
  public cachingStatus: boolean;
  public isMobile: boolean;
  public pageCount: string;
  public stats: IBoosterStats;
  public notConnected: boolean;
  public user: User;
  public hostedCounts: any;
  public managerLink: string;
  companyName: string = 'Dashboard';

  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _route: ActivatedRoute,
    private _store: Store<fromStore.DbStoreState>,
    private _builderSectionsInteractionService: BuilderSectionsInteractionService
  ) { }

  ngOnInit() {
    if (!TypeUtils.isNull(this._route.snapshot.data['boosterTroubleshootData'])) {
      const disconnected = this._route.snapshot.data['boosterTroubleshootData'] === 'alive_but_not_connected';
      const restNoRoute = this._route.snapshot.data['boosterTroubleshootData'] === 'error';
      this.notConnected = disconnected || restNoRoute;
    }
    if (window.innerWidth < 991) {
      this.isMobile = true;
    }
    this._initData();
    this.addScrollListener();

    this._store.select(fromStore.getTenWebProductsLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getTenWebManagerPlugin)),
        first()
      ).subscribe(managerPlugin => {
      this.managerLink = managerPlugin && managerPlugin.downloadLink;
    });
    this._getCompanyInfo();
  }

    private _getCompanyInfo(): void {
        this._builderSectionsInteractionService.companyInfo
            .pipe(
                filter(companyInfo => !!companyInfo),
                takeUntil(this._destroyStream$),
                first()
            )
            .subscribe(companyInfo => {
                this.companyName = companyInfo?.branding?.company_name || companyInfo?.agency?.name || 'YourBrand';
            });
    }

  private _getPageCount(): void {
    this._store.select(fromStore.getWebsiteBoosterPagesCount(this.website?.id))
      .pipe(
        filter(pageCount => !!pageCount)
      )
      .subscribe(pageCount => {
        this.pageCount = TypeUtils.isDefined(pageCount) ? pageCount : null;
      });
  }

  private _getWebsiteBoosterStats(): void {
    this._store.select(fromStore.getWebsiteBoosterStats(this.website?.id))
      .pipe(
        takeUntil(this._destroyStream$)
      )
      .subscribe((stats): void => {
        if (!TypeUtils.isNull(stats)) {
          this.stats = stats;
        }
      });
  }

  private _initData(): void {
    this.currentSubscription = this._route.snapshot.parent.parent.data['userSubscription'];
    this.website = this._route.snapshot.parent.parent.data['website'];
    this.user = this._route.snapshot.parent.parent.data['user'];
    this._getUserSubscriptionData();
    this._getWebsite();
    this._getCacheStats(this.website?.id);
    this._getPageCount();
    this._getWebsiteBoosterStats();
  }

  private _getWebsite(): void {
    this._store.select(fromStore.getWebsitesLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getWebsites),
          this._store.select(fromStore.getWebsite(this.website?.id))
        )),
        takeUntil(this._destroyStream$)
      )
      .subscribe(([websites, website]) => {
        this.website = website;
        this.hostedCounts = websites.filter((_website: Website) => !!_website.domain_hash);
      });
  }
  private _getUserSubscriptionData(): void {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() =>
          this._store.select(fromStore.getUserSubscription)
        ),
        takeUntil(this._destroyStream$)
      )
      .subscribe((currentSubscription) => {
        this.currentSubscription = currentSubscription;
      });
  }

  private _getCacheStats(websiteId): void {
    this._store.select(fromStore.getWebsiteBoosterCacheStats(websiteId))
      .pipe(
        takeUntil(this._destroyStream$)
      )
      .subscribe(cacheStats => {
        this.cachingStatus = cacheStats && cacheStats.cacheEnabled;
      });
  }

  private addScrollListener() {
    if (!this.isMobile) {
      const parent = document.getElementsByTagName("db-back-end") && document.getElementsByTagName("db-back-end")[0] && document.getElementsByTagName("db-back-end")[0];
      const webpNotice = document.getElementsByClassName('ds-notification-warning-webp');
      const cacheNotice = document.getElementsByClassName('ds-notification-warning-cache');
      const subscriptionBlock = document.getElementsByClassName('db-subscription-block'); // 224 block height
      let stickyScrolled = 22 + 224;
      webpNotice && webpNotice[0] && (stickyScrolled = stickyScrolled + webpNotice[0].clientHeight);
      cacheNotice && cacheNotice[0] && (stickyScrolled = stickyScrolled + cacheNotice[0].clientHeight);
      parent.addEventListener("scroll", function(e) {
        if (document.getElementsByTagName("db-back-end")[0].scrollTop > stickyScrolled) {
          document.getElementById("db-optimize-with-booster-pro") && document.getElementById("db-optimize-with-booster-pro").classList.add("sticky-backend");
        } else {
          document.getElementById("db-optimize-with-booster-pro") && document.getElementById("db-optimize-with-booster-pro").classList.remove("sticky-backend");
        }
      });
    }
  }
}
